import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVerticalAlignmentCenter: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconVerticalAlignmentCenter"><Path d="M12.75 3H11.25V6H4V11H11.25V13H6V18H11.25V21H12.75V18H18V13H12.75V11H20V6H12.75V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVerticalAlignmentCenter;
